import React from 'react';
import { CalendarClock } from 'lucide-react';

const eur = (v) => `${Number(v || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

const PASTILLES = {
  regle: ['Réglé', 'bg-emerald-100 text-emerald-700'],
  en_attente: ['En attente', 'bg-slate-100 text-slate-600'],
  prelevee: ['Prélevée', 'bg-emerald-100 text-emerald-700'],
  a_venir: ['À venir', 'bg-sky-100 text-sky-700'],
  rejetee: ['Rejetée', 'bg-red-100 text-red-700'],
  annulee: ['Annulée', 'bg-slate-200 text-slate-600'],
};

function Pastille({ statut, testId }) {
  if (!statut || !PASTILLES[statut]) return null;
  const [label, cls] = PASTILLES[statut];
  return <span className={`ml-1 whitespace-nowrap rounded-full px-1.5 py-px text-[9px] font-bold ${cls}`} data-testid={testId}>{label}</span>;
}

export function EcheancierCarte({ ech, docId }) {
  if (!ech) return null;
  return (
    <div className="mt-3 rounded-lg border border-amber-200 bg-amber-50/70 p-2 text-left text-[10px] text-amber-900" data-testid={`proposition-echeancier-${docId}`}>
      <div className="mb-1 flex items-center gap-1 font-bold uppercase tracking-wide">
        <CalendarClock className="h-3 w-3" /> Échéancier
      </div>
      <div className="flex items-center justify-between font-semibold">
        <span>Acompte {ech.acompte_pct} %{ech.acompte_date_fr ? ` le ${ech.acompte_date_fr}` : ''}
          <Pastille statut={ech.acompte_statut} testId={`proposition-acompte-statut-${docId}`} /></span>
        <span className="whitespace-nowrap pl-1">{eur(ech.acompte_eur)}</span>
      </div>
      {ech.echeances.map((e, i) => (
        <div key={e.label} className="flex items-center justify-between text-amber-800">
          <span>{e.label} · {e.date_fr}<Pastille statut={e.statut} testId={`proposition-echeance-statut-${docId}-${i + 1}`} /></span>
          <span className="whitespace-nowrap pl-1">{eur(e.montant_eur)}</span>
        </div>
      ))}
    </div>
  );
}
